export { Moon3 as default } from './Moon3';
